import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import mx from "@/locales/mx.json";

// Thank you page is Spanish-only per requirement.
const ThankYou = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = mx.thankYou.title;
  }, []);

  const t = (key) => {
    const parts = key.split(".");
    let value = mx;
    for (const p of parts) value = value?.[p];
    return value;
  };

  return (
    <div
      className="flex min-h-screen flex-col bg-[#F8FAFC]"
      data-testid="thank-you-page"
    >
      <header className="border-b border-[#0b224a] bg-[#0F2C59] text-white">
        <div className="mx-auto flex max-w-6xl items-center gap-3 px-5 py-4 lg:px-8">
          <span
            aria-hidden="true"
            className="flex h-10 w-10 items-center justify-center rounded-md border border-[#D4AF37]/60 bg-[#0b224a] font-serif text-lg font-semibold text-[#D4AF37]"
          >
            K
          </span>
          <span className="font-serif text-lg font-semibold">
            Kredamontiva
          </span>
        </div>
      </header>
      <main className="mx-auto flex w-full max-w-3xl flex-1 flex-col justify-center px-5 py-20 lg:px-8">
        <p className="text-xs uppercase tracking-widest text-[#0D7A5F]">
          {t("thankYou.eyebrow")}
        </p>
        <h1 className="mt-4 font-serif text-3xl font-bold text-[#0F2C59] sm:text-4xl lg:text-5xl">
          {t("thankYou.title")}
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#475569]">
          {t("thankYou.message")}
        </p>

        <div className="mt-10 rounded-md border border-[#E2E8F0] bg-white p-6">
          <p className="font-serif text-lg font-semibold text-[#0F2C59]">
            {t("thankYou.supportTitle")}
          </p>
          <p className="mt-2 text-sm text-[#475569]">
            {t("thankYou.supportText")}
          </p>
        </div>

        <div className="mt-10">
          <button
            type="button"
            onClick={() => navigate("/")}
            className="inline-flex items-center justify-center rounded-md bg-[#0D7A5F] px-6 py-3 text-sm font-semibold text-white hover:bg-[#0B6B53]"
            data-testid="thank-you-back-home"
          >
            {t("thankYou.backHome")}
          </button>
        </div>
      </main>
      <footer className="border-t border-[#E2E8F0] bg-white">
        <div className="mx-auto max-w-6xl px-5 py-6 text-xs text-[#64748B] lg:px-8">
          © 2026 Kredamontiva Consultoría Financiera S.A.P.I. de C.V.
        </div>
      </footer>
    </div>
  );
};

export default ThankYou;
